import React, { useState } from 'react'

import {
	BusinessListItem,
	CollaboratorListItem,
	ContributorListItem,
	ResourceListItem,
	Container,
	ShapeImage,
	Image,
} from './'

let resourceLinks  = [
	"https://mailchimp.com/",


	"https://mailchimp.com/courier/",

	"https://mailchimp.com/presents/"
	
	
];

const ListItem = (props) => {
	const { data, category, index, first } = props
	const [hovered, setHovered] = useState(false)
	return (
		<Container category={category}>
			{category === 'Business' && (
				<>
					<ShapeImage
						src={data}
						active={hovered}
						index={index}
						category={category}
						first={first}
					/>
					<BusinessListItem
						{...props}
						setHovered={setHovered}
						hovered={hovered}
					/>
				</>
			)}

			{category === 'Contributor' && (
				<>
					<ShapeImage
						src={data}
						active={hovered}
						index={index}
						category={category}
						first={first}
					/>
					<ContributorListItem
						{...props}
						setHovered={setHovered}
						hovered={hovered}
					/>
				</>
			)}
			{category === 'Collaborator' && (
				<>
					<Image src={data} category={category} />
					<CollaboratorListItem
						{...props}
						setHovered={setHovered}
						hovered={hovered}
					/>
				</>
			)}
			{category === 'Resources' && (
				<>
					<a href={[resourceLinks[index - 1]]} target="_blank">
						<Image src={data} category={category} />
					</a>
					
					<ResourceListItem
						{...props}
						setHovered={setHovered}
						hovered={hovered}
					/>
				</>
			)}
		</Container>
	)
}

export default ListItem
